import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea'

@Component({
    selector: 'formly-primeng-texarea',
    imports: [ReactiveFormsModule, TextareaModule],
    template: `
        <textarea pTextarea fluid [id]="key" [rows]="10" [formControl]="formControl"></textarea>
    `,
})

export class InputTextareaCosmos extends FieldType<FieldTypeConfig> {

    ngOnInit() { }
}